import { Cart, CartModificationList } from '@spartacus/cart/base/root';
import { Observable } from 'rxjs';
import { GenAutoShipEntriesRequest } from '../../../../models/auto-ship.model';

export abstract class GenAutoShipCartAdapter {
  abstract load(userId: string, cartId: string): Observable<Cart>;

  abstract updateEntries(
    userId: string,
    cartId: string,
    request: GenAutoShipEntriesRequest,
  ): Observable<CartModificationList>;
}
